import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent } from '../../schema'

type Response = OpalApiComponent<'V2', 'response'>

type Attributes = {
  details: OpalApiComponent<'V2', 'response'>['attributes']['details']
  assignmentId: string
}

const defaultAttributes: Omit<
  OpalApiComponent<'V2', 'response'>['attributes'],
  'details'
> = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  deleted_at: null,
}

export const resourceObject = ({
  details,
  assignmentId,
}: Attributes): Response => ({
  id: uuidv4(),
  type: 'response',
  attributes: {
    ...defaultAttributes,
    details,
  },
  relationships: {
    assignment: {
      data: { id: assignmentId, type: 'assignment' },
    },
    created_by_user: {
      data: { id: uuidv4(), type: 'user' },
    },
  },
})
